import { Component } from '@angular/core'
import { ColumnControlBaseComponent } from '../base/column-control-base.component'
import { ICustomTableColumnButton } from '../../modals/interface/custom-table.interface'

@Component({
    selector: 'app-column-control-button',
    templateUrl: './column-control-button.component.html',
    styleUrls: ['./column-control-button.component.scss'],
    standalone: false
})
export class ColumnControlButtonComponent extends ColumnControlBaseComponent {
  public get btn(): ICustomTableColumnButton {
    return this.column.button
  }
}
